import * as React from "react";
import styled from "styled-components";

export const WIDTH = 160;
export const HEIGHT = 208;

const Name = styled.p`
  margin: 4px;
  font-family: Ubuntu;
  font-size: 18px;
  font-weight: 500;
  text-align: center;
`;

const Job = styled(Name)`
  font-size: 14px;
  font-weight: 100;
`;

interface Picture {
  sources: Array<{
    srcSet: string;
    type: string;
  }>;
  img: string;
}

export interface Props {
  portrait: Picture;
  tache: string;
  name: string;
  job: string;
}

const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Tache = styled.img`
  opacity: 0;
  position: absolute;

  ${Container}:hover & {
    opacity: 1;
  }
`;

const Portrait = styled.picture`
  filter: brightness(0%);
  height: ${HEIGHT}px;
  width: ${WIDTH}px;
`;

const PortraitFallback = styled.img`
  filter: brightness(0%);
  height: ${HEIGHT}px;
  width: ${WIDTH}px;
`;

export const Member = ({
  portrait: { sources, img },
  tache,
  name,
  job,
}: Props) => (
  <div style={{ margin: "0 24px" }}>
    <Container>
      <Tache src={tache} alt="" />
      <Portrait>
        {sources.map(({ srcSet, type }, index) => (
          <source key={index} srcSet={srcSet} type={type} />
        ))}
        <PortraitFallback src={img} alt={name} />
      </Portrait>
    </Container>
    <Name>{name}</Name>
    <Job>{job}</Job>
  </div>
);
